module.exports = __webpack_public_path__ + "img/ico-check-off.d7392882.svg";